import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from "react";
import { StyledLink } from "./TextLink.styles";
var TextLink = /*#__PURE__*/ forwardRef(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, text = _param.text, _as = _param.as, as = _as === void 0 ? "a" : _as, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _blendIn = _param.blendIn, blendIn = _blendIn === void 0 ? false : _blendIn, props = _object_without_properties(_param, [
        "children",
        "text",
        "as",
        "variant",
        "disabled",
        "blendIn"
    ]);
    return _jsx(StyledLink, _object_spread_props(_object_spread({
        ref: ref,
        type: as === "button" ? "button" : undefined
    }, props), {
        href: as === "button" ? undefined : props.href,
        as: as,
        variant: variant,
        $disabled: disabled,
        disabled: disabled && as === "button" ? disabled : undefined,
        "aria-disabled": disabled ? "true" : undefined,
        blendIn: blendIn,
        children: children || text
    }));
});
export { TextLink };
